import React, { lazy, Suspense } from 'react';

const LazySales = lazy(() => import('./Sales'));

const Sales = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }|any) => (
  <Suspense fallback={null}>
    <LazySales {...props} />
  </Suspense>
);

export default Sales;
